module.exports = __webpack_public_path__ + "static/media/cloud.5f73b754.svg";